:host {
  --background-color: #0c4f9a;

  box-sizing: border-box;
  display: flex;
  gap: 1rem;

  font: inherit;
}

.icon-container {
  background-color: var(--background-color);
  display: flex;
  padding: .75rem;
  border-radius: .75rem;
  flex-grow: 0;
  width: 2rem;
  height: 2rem;
}

:host([inverted]) ::slotted(p) {
  color: #dbdbdb;
}

.icon-container > img {
  width: inherit;
  height: inherit;
  filter: brightness(0) invert(1);
}

slot {
  display: flex;
  flex-direction: column;
}

::slotted(*) {
  margin: 0;
}

::slotted(p) {
  color: #4b5563;
}

@media (min-width: 1500px) {
  .icon-container {
    align-self: center;
    background-color: transparent;
    padding: .75rem;
    border-radius: .75rem;
    width: 3rem;
    height: 3rem;
  }


  :host([inverted]) .icon-container {
    background-color: transparent;
  }

  .icon-container > img {
    filter: none;
  }

}
